import { reactive } from 'vue'
import actions from '@/store/progress/actions'
import state from '@/store/progress/state'
import getters from '@/store/progress/getters'

export const progressModule = {
    state: reactive(state),
    actions,
    getters,
}
